import axiosClient from './axiosClient';

export interface IFeedbackBody {
  type: 'bug' | 'feature' | 'general';
  message: string;
  email?: string;
}

const feedbackApis = {
  submit: (body: IFeedbackBody) => axiosClient.post('/feedback', body),
};

export default feedbackApis;
